import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import { Tabs, Tab } from '@mui/material';
import TripadvanceTable from 'components/tripadvance/TripadvanceTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import TripadvanceServices from 'services/TripadvanceServices';
import { FiRefreshCcw } from 'react-icons/fi';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';

import sidebar from 'routes/sidebar';
import LabelArea from 'components/form/LabelArea';
import InputSearchDate from 'components/form/InputSearchDate';

const Tripadvance = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const id_employee = adminInfo?.id ? adminInfo.id : 0;
	const [loading, setLoading] = useState(false);
	const { isUpdate, setIsUpdate } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [tab, setTab] = useState(0);
	const [error, setError] = useState(false);
	const [tripadvanceData, setTripadvanceData] = useState([]);
	const [status, setStatus] = useState(false);

	const {
		tripadvanceRef,
		dataTable,
		serviceData,
		handleSubmitTripadvance,
		currentPage,
	} = useFilter(tripadvanceData, itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	const [searchstartDate, setSearchStartDate] = useState(null);
	const [searchendDate, setSearchEndDate] = useState(null);
	const formatDate = (date) => {
		if (!date) return null;
		const d = new Date(date);
		const day = String(d.getDate()).padStart(2, '0');
		const month = String(d.getMonth() + 1).padStart(2, '0');
		const year = d.getFullYear();
		return `${day}-${month}-${year}`;
	};
	const formattedDates = {
		start_date: searchstartDate ? formatDate(searchstartDate) : '',
		end_date: searchendDate ? formatDate(searchendDate) : '',
	};

	// const totalResults = groupedArray.length;

	useEffect(() => {
		const fetchTripadvance = async () => {
			setLoading(true);
			var date = {
				from: formattedDates.start_date,
				to: formattedDates.end_date,
			};
			try {
				let response;
				if (tab === 0) {
					response = await TripadvanceServices.getTripadvanceList(1, date);
				} else if (tab === 1) {
					response = await TripadvanceServices.getTripadvanceList(4, date);
				}
				// console.log("response data", response);
				
				const updatedData =
					response?.data?.map(
						({
							id,
							ref_no,
							client_name,
							start_date,
							arrival,
							departure,
							vehicle_type,
							vendor_name,
							trip_advance_request,
							trip_advance_paid,
							approval_status,
							paid_status,
							paid_remark,
							approved_remark,
							paid_date,
							utr,
							payment_type,
							vehicle_driver_change_remark,

							...rest
						}) => ({
							id,
							ref_no,
							client_name,
							start_date,
							arrival,
							departure,
							vehicle_type,
							vendor_name,
							trip_advance_request,
							trip_advance_paid,
							approval_status,
							paid_status,
							paid_remark,
							approved_remark,
							paid_date,
							utr,
							payment_type,
							vehicle_driver_change_remark,
							...rest,
						})
					) || [];
				setTripadvanceData(updatedData);
				setStatus(response?.status);
				setLoading(false);
			} catch (error) {
				setLoading(false);
				setError(true);
				console.error('Error fetching tripadvance:', error);

				// notifyError("Failed to fetch tripadvance. Please try again later.");
			}
		};
		fetchTripadvance();
		setIsUpdate(false);
		// eslint-disable-next-line
	}, [tab, isUpdate]);

	const handleTabChange = (event, newValue) => {
		setTab(newValue);
	};

	const handleSearch = () => {
		setIsUpdate(true);
	};
	// const totalResults = filteredAgents.length;

	// Slice data for the current page
	// const paginatedTripadvance = groupedArray.slice(
	//   (currentPage - 1) * itemsPerPage,
	//   currentPage * itemsPerPage
	// );
	// const paginatedTripadvance = groupedArray.slice(
	//   (currentPage - 1) * perpage,
	//   currentPage * perpage
	// );

	// const hideView = adminInfo?.permission?.some(
	//   (perm) => perm.id_tab === "tripadvance" && perm.view === 1
	// );
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'tripadvance request' && perm.view === 1
		  );

	const hideEdit = isAdmin
	    ? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'tripadvance request' && perm.edit === 1
		);

	const hideEport = isAdmin
	    ? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'tripadvance request' && perm.export === 1
		);
	
	const hideAdd = isAdmin
	    ? true
		: adminInfo?.permission?.some(
			(perm) => perm.id_tab === 'tripadvance request' && perm.add === 1
		);

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<PageTitle sidebar={sidebar().sidebar} />
					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
						<CardBody>
							<div className="flex flex-wrap items-center gap-3">
								<div className="flex items-center gap-3">
									<div className="flex items-center gap-2">
										<LabelArea label="From" />
										<div className="w-50">
											<InputSearchDate
												value={searchstartDate}
												onChange={(event) => setSearchStartDate(event)}
											/>
										</div>
									</div>

									<div className="flex items-center gap-2">
										<LabelArea label="To" />
										<div className="w-50">
											<InputSearchDate
												value={searchendDate}
												min={searchstartDate}
												onChange={(event) => setSearchEndDate(event)}
											/>
										</div>
									</div>
								</div>

								<div className="flex-1">
									<Input
										ref={tripadvanceRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitTripadvance}
									/>
								</div>

								<div>
									<Button
										className="rounded-md h-10 px-8"
										onClick={() => {
											handleSearch();
										}}
									>
										Search
									</Button>
								</div>
								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>
					<Tabs
						value={tab}
						onChange={handleTabChange}
						TabIndicatorProps={{
							style: { backgroundColor: '#057a55' },
						}}
						sx={{
							'& .MuiTab-root': {
								textTransform: 'capitalize',
							},
						}}
					>
						{/* <Tab label="All" /> */}
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Request"
						/>
						<Tab
							className="focus:outline-none dark:text-white"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Status"
						/>
						{/* {tab === 4 && (
    <div className="flex gap-4 mt-4">
      <button
        className={`px-4 py-2 rounded ${
          paymentStatus === "unpaid" ? "bg-green-500 text-white" : "bg-gray-200"
        }`}
        onClick={() => setPaymentStatus("unpaid")}
      >
        Unpaid
      </button>
      <button
        className={`px-4 py-2 rounded ${
          paymentStatus === "paid" ? "bg-green-500 text-white" : "bg-gray-200"
        }`}
        onClick={() => setPaymentStatus("paid")}
      >
        Paid
      </button>
    </div>
  )} */}
					</Tabs>
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="capitalize z-10 text-center sticky top-0 text-sm">
											<tr>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Ref No.</TableCell>
												<TableCell>Client Name </TableCell>
												<TableCell>Trip Date</TableCell>
												<TableCell>Arrival / Departure</TableCell>
												<TableCell>No of Days</TableCell>
												<TableCell>Vehicle Type</TableCell>
												{tab === 0 && <TableCell>Itinerary</TableCell>}
												<TableCell>Vendor Name</TableCell>
														<TableCell>Travel Date</TableCell>
												<TableCell>Advance Request</TableCell>
												<TableCell>Status</TableCell>
												{tab !== 1 && <TableCell>Action</TableCell>}
											</tr>
										</TableHeader>
										<TripadvanceTable
											tripadvance={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											tab={tab}
											hideView={hideView}
											hideEdit={hideEdit}
											hideExport={hideEport}
											hideAdd={hideAdd}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<NotFound title="There are no Trip Advance." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Tripadvance;
